import { registerLayout, ViewType } from '@kunlun/dependencies';

export const install = () => {
  // 表格视图
  registerLayout(
    `
      <view type="TABLE">
        <element widget="SalesRatioControlHintBanner" slot="hintBanner" />
        <pack widget="group">
          <view type="SEARCH">
            <element widget="search" slot="search" slotSupport="field" />
          </view>
        </pack>
        <element widget="actionBar" slot="actionBar" slotSupport="action">
          <xslot name="actions" slotSupport="action" />
        </element>
        <element widget="table" slot="table">
          <element widget="field" name="controlLevel" />
          <element widget="field" name="channelTypeCode" />
          <element widget="field" name="channelType" />
          <element widget="field" name="provincialBranchName" />
          <element widget="field" name="salesOfficeName" />
          <element widget="field" name="customerCode" />
          <element widget="field" name="customerName" />
          <element widget="field" name="promoSalesRatio" />
          <element widget="field" name="customerMarginRatio" />
          <element widget="field" name="provinceMarginRatio" />
          <element widget="field" name="oldProductMarginRate" />
          <element widget="field" name="newProductMarginRate" />
          <element widget="field" name="writeDate" />
          <element widget="field" name="writeUid" />
          <element widget="rowActions" slot="rowActions" />
        </element>
      </view>
    `,
    {
      viewType: ViewType.Table,
      model: 'deli.aries.platform.DeliAriesPlatformSalesRatioControlConfig',
      name: 'salesRatioControlConfigList'
    }
  );

  // 表单视图（创建/编辑）由 SalesRatioControlConfigForm.ts 按 model + viewType + moduleName 整页接管
};

install();
